"use client";
import useMediaQueryBase from "@repo/shared-ui/useMediaQuery";

export function useMediaQuery(breakpoint: number = 768) {
  return useMediaQueryBase(`(max-width: ${breakpoint}px)`);
}
